import { useState } from 'react';

function IngredientsFooter({ ingredientsList }) {

  const [showMenu, setShowMenu] = useState(false);

  return (
    <div id="ingredients-modal">
      {!showMenu &&
        <button className="modal-trigger" onClick={() => setShowMenu(!showMenu)}>Ingredients</button>
      }
      <div className="modal-wrapper" data-show-menu={showMenu}>
        <div className="modal-overlay" onClick={() => setShowMenu(!showMenu)}></div>
        <div className="modal-content">
          <header onClick={() => setShowMenu(!showMenu)}>
            <h3>Ingredients</h3>
            <button className="icon small"></button>
          </header>
          <div className="ingredients-container">{ingredientsList}</div>
        </div>
      </div>
    </div>
  );
}

export default IngredientsFooter;